import { Box, Button, Typography } from '@mui/material';
import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import notFoundImage from '@/assets/img/not-found.png';
import { MenuItem } from '@/components/layout/sidebar/SidebarMenuItems';
import SidebarMenuItemsContext from '@/contexts/sidebar-menu-items';

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarMenuItems = useContext(SidebarMenuItemsContext);

  const routeToNavigateToOnIndexPage = (function findFirstVisibleMenuItem(
    items: MenuItem[]
  ): Extract<MenuItem, { type: 'menu-item' }> | null {
    for (const menuItem of items) {
      if (!menuItem.isHidden) {
        if (menuItem.type === 'menu-item') {
          return menuItem as Extract<MenuItem, { type: 'menu-item' }>;
        }
        if (menuItem.type === 'sub-menu') {
          const nestedResult = findFirstVisibleMenuItem(menuItem.items);
          if (nestedResult) {
            return nestedResult;
          }
        }
      }
    }
    return null;
  })(sidebarMenuItems);

  useEffect(() => {
    if (
      (location.pathname === '/' || location.pathname === '') &&
      !location.search.includes('?code') // authentication redirect
    ) {
      navigate(routeToNavigateToOnIndexPage?.to ?? '/dashboard', {
        replace: true,
      });
    }
  }, [location, navigate, routeToNavigateToOnIndexPage]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <img
        src={notFoundImage}
        style={{ maxWidth: '100%', height: '70%', objectFit: 'contain' }}
        alt="Forbidden Access"
      />
      <Typography
        variant="h1"
        textAlign="center"
        sx={{
          top: '-80px',
          fontSize: '5rem',
          position: 'relative',
          wordBreak: 'break-word',
          inlineSize: {
            md: '100%',
            lg: '50%',
          },
        }}
      >
        Page Not Found
      </Typography>
      <Button
        variant="contained"
        sx={{
          top: '-60px',
        }}
        size="large"
        onClick={() =>
          navigate(routeToNavigateToOnIndexPage?.to ?? '/dashboard')
        }
      >
        Go home
      </Button>
    </Box>
  );
}
